<template>
  <div 
    id="app" 
    :key="app_key" 
    :class="['overflow-hidden',`theme-${$store.state.app.theme}`]"
    >
    <UiLoading v-if="0 && (ui.loading || !ui.init)" class="overlay big" />
    <div class="frame-wrap" v-else>
      <Topnav />
      <div class="pb-6 overflow-hidden">
        <router-view :key="$route.path" class="flex-auto" />
      </div>

      <SiteFooter/>
    </div>
    <Notifications />
    <storeWatch/>
  </div>
</template>

<script>
import bus from '@/bus.js'

import { mapActions } from 'vuex';
//import spaces from '@/spaces';
import storeWatch from './views/storeWatch.vue'

export default {
  components: {
    storeWatch
  },
  data(){
    return {
      app_key: 0,
    }
  },
  computed: {
    wrongNetwork() {
      return this.config.chainId !== this.web3.injectedChainId;
    },
    showLogin() {
      return (
        (!this.web3.account && !this.web3.injectedLoaded) ||
        (!this.web3.account && !this.wrongNetwork)
      );
    },
    /*
    space() {
      try {
        return spaces[this.$route.params.key];
      } catch (e) {
        return {};
      }
    }
    */
  },
  watch: {
    '$store.state.app.lang'(){
      let v = this
      v.app_key += 1
    },
  },
  methods: {
    ...mapActions([
      'init',
      'getLavaPrice',
      'getHTPrice',
    ]),

    reloadApp(){
      this.app_key += 1
      // this.$store.hotUpdate()
    },
    
    async uniGetLavaPrice(){
      let v = this
      // console.log('===getLavaPrice()')
      let price = await v.getLavaPrice({})

      bus.lava_price = price
      v.$store.commit('setWeb3Data',{
        token_lava_price: price,
      })
    },

    async uniGetHtPrice(){
      let v = this
      // console.log('===getLavaPrice()')
      let price = await v.getHTPrice({})

      v.$store.commit('setWeb3Data',{
        token_ht_price: price,
      })
    },

    run(){
      let v = this
      v.uniGetLavaPrice()
      v.uniGetHtPrice()

      // init lang
      let str_lang = window.localStorage.getItem('lang')
      if(['zh','en'].indexOf(str_lang) >= 0 && v.$store.state.app.lang != str_lang){
        v.$store.commit('lang',str_lang)
      }
      // init theme
      let str_theme = window.localStorage.getItem('theme')
      if(['light','dark'].indexOf(str_theme) >= 0 && v.$store.state.app.theme != str_theme){
        v.$store.commit('theme',str_theme)
      }
    },
  },
  created(){
    // 
    bus.appvue = this
  },
  mounted() {
    this.init();
    this.run()
    window._bus = bus
  },
};
</script>
<style lang="scss">
  @import '~@/assets/css/style.scss';

  .frame-wrap{
    min-height: 100vh;

    // 给icon留空间
    padding-bottom: 200px;
  }
</style>
